import type {ExtractPropsWithoutRef} from '@/types';

import {BenefitBanner as BenefitBannerUI} from '@travel-frontend/ui-components';
import {memo} from 'react';

type Props = ExtractPropsWithoutRef<typeof BenefitBannerUI>;

export const BenefitBanner: React.FunctionComponent<Props> = memo(
  function BenefitBanner({headline, benefits, ...restProps}) {
    if (!headline || !benefits || benefits.length === 0) {
      return null;
    }

    return (
      <BenefitBannerUI headline={headline} benefits={benefits} {...restProps} />
    );
  }
);
